<template>
  <div class="data-head">
    <h2 v-if="title" class="data-head__title">{{ title }}</h2>

    <div v-if="image?.src" class="data-head__image">
      <img :src="image.src" :alt="image.alt || ''" />
    </div>

    <div class="data-head__text">
      <h3 v-if="subTitle" class="data-head__subtitle">{{ subTitle }}</h3>
      <p v-if="description" class="data-head__description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataCuesHeader',
  props: {
    title: String,
    image: Object,
    subTitle: String,
    description: String
  }
}
</script>

<style lang="scss" scoped src="./DataCuesHeader.scss"></style>


